export default "__VITE_ASSET__CmawTYSM__"